import labels from './labels.json';
import validation from './validation.json';

export const forms = {
  labels,
  validation,
};
